// extracted by mini-css-extract-plugin
export default {"container":"style_container__XxJpf","text":"style_text__-UcNc","darkText":"style_darkText__8y9ir","smallText":"style_smallText__U1S6F","locationIcon":"style_locationIcon__X-9Gh"};